enum EOriginQuest {
	fromCampaign = 'fromCampaign',
	fromQuest = 'fromQuest',
	fromQuestLog = 'fromQuestLog',
	unset = 'unset'
}

export { EOriginQuest };
